import { useQueryClient } from '@tanstack/react-query';


const useLogout = () => {
    const queryClient = useQueryClient();

    const logout = async () => {
        localStorage.removeItem(process.env.REACT_APP_TOKEN_NAME);
        await queryClient.invalidateQueries();
        queryClient.clear();
        window.location.href = '/'; // redirect to home
    };

    return logout;
};

export default useLogout;